export default function getResource(label) {
    const resources = {
        free: 'FREE',
        value: 'value',
        errorModalTitle: 'Item Out of Stock',
        errorModalText: 'Sorry, this item is out of stock. It will not be added to your basket.',
        errorModalButton: 'Got It'
    };
    return resources[label];
}
